@if (isMultipleSelection) {
  <mat-checkbox
    (change)="onChange($event)"
    [checked]="(checked$ | async) ?? false"
    [indeterminate]="indeterminate$ | async">
  </mat-checkbox>
}
